{
  "schemaVersion": "qec-trace-0.3",
  "engineVersion": "1.0.0",
  "pathMapVersion": "qec-path-map-0.3.0",
  "manifestationVersion": "qec-manifestation-0.2",
  "program": "אור",
  "programHash": "fnv1a32-ddb3d910",
  "seed": 9,
  "initialState": [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    9
  ],
  "events": [
    {
      "sequence": 0,
      "instructionIndex": 0,
      "letter": "א",
      "transform": "preserve-frame",
      "route": [
        "Keter",
        "Tiferet"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "KeterService",
        "TiferetScheduler"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        9
      ],
      "after": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        9
      ],
      "beforeHash": "016f73a5",
      "afterHash": "016f73a5",
      "coherence": {
        "activation": 0.811,
        "phase": 0.023,
        "coherence": 0.962
      }
    },
    {
      "sequence": 1,
      "instructionIndex": 1,
      "letter": "ו",
      "transform": "mirror-exchange",
      "route": [
        "Hod",
        "Yesod"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "HodInterface",
        "YesodBus"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        9
      ],
      "after": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        0,
        0,
        0,
        2,
        4,
        0,
        0,
        2,
        0,
        0,
        0,
        9
      ],
      "beforeHash": "016f73a5",
      "afterHash": "41ded33f",
      "coherence": {
        "activation": 0.767,
        "phase": 4.588,
        "coherence": 0.763
      }
    },
    {
      "sequence": 2,
      "instructionIndex": 2,
      "letter": "ר",
      "transform": "seed-rotation",
      "route": [
        "Yesod",
        "Malchut"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "YesodBus",
        "MalchutOutput"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        0,
        0,
        0,
        2,
        4,
        0,
        0,
        2,
        0,
        0,
        0,
        9
      ],
      "after": [
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
      ],
      "beforeHash": "41ded33f",
      "afterHash": "67f89eb3",
      "coherence": {
        "activation": 0.698,
        "phase": 5.159,
        "coherence": 0.94
      }
    }
  ],
  "completeTraceHash": "fnv1a32-8b612e3f",
  "observation": {
    "step": 3,
    "reason": "program-end",
    "stateHash": "6661dece",
    "traceHash": "fnv1a32-8b612e3f",
    "candidates": [
      {
        "id": "register-order",
        "label": "Register order",
        "stateHash": "5f61d3c9",
        "focusLetter": "ד",
        "confidence": 0.523,
        "rationale": "Reads the manifested registers in machine order."
      },
      {
        "id": "mirror-order",
        "label": "Mirror order",
        "stateHash": "ccd7cd88",
        "focusLetter": "ה",
        "confidence": 0.771,
        "rationale": "Reads the same state through its paired-register reflection."
      },
      {
        "id": "phase-offset",
        "label": "Aleph Olam phase",
        "stateHash": "0d0e0c81",
        "focusLetter": "ר",
        "confidence": 0.708,
        "rationale": "Projects the state through the shared Aleph Olam orientation."
      }
    ],
    "selectedProjection": "register-order",
    "snapshot": [
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9
    ]
  }
}
